import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contrasenha',
  templateUrl: './contrasenha.component.html',
  styleUrls: ['./contrasenha.component.css']
})
export class ContraSenhaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
